export default {"src":"/_next/static/media/404.f65f8115.svg","height":148,"width":173,"blurWidth":0,"blurHeight":0};